import { Button } from "@/components/ui/button";
import { Phone, CheckCircle2, Shield, Calendar, Sparkles } from "lucide-react";

export const HeroSection = () => {
  const scrollToBooking = () => {
    const element = document.getElementById("booking");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="hero-gradient pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-8 animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-sky-100 rounded-full">
              <Sparkles className="w-4 h-4 text-sky-600" />
              <span className="text-sm font-medium text-sky-700">
                Professional Pet Care
              </span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Professional Pet Grooming Services in{" "}
              <span className="gradient-text">New York City</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-xl">
              Gentle, safe, and stress-free grooming for dogs and cats. 
              Give your furry friend the pampering they deserve.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-book-btn"
                onClick={scrollToBooking}
                size="lg"
                className="rounded-full px-8 py-6 text-base font-semibold bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 shadow-lg shadow-sky-200 transition-all hover:-translate-y-0.5 cta-pulse"
              >
                Book Your Pet's Appointment
              </Button>
              <Button
                data-testid="hero-call-btn"
                asChild
                variant="outline"
                size="lg"
                className="rounded-full px-8 py-6 text-base font-semibold bg-white border-slate-200 hover:bg-slate-50 hover:border-sky-200"
              >
                <a href="tel:+15125550123">
                  <Phone className="w-5 h-5 mr-2" />
                  Call Now
                </a>
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-4 pt-4">
              <div className="trust-badge">
                <CheckCircle2 className="w-4 h-4" />
                <span>Experienced Groomers</span>
              </div>
              <div className="trust-badge">
                <Shield className="w-4 h-4" />
                <span>Clean & Safe Facility</span>
              </div>
              <div className="trust-badge">
                <Calendar className="w-4 h-4" />
                <span>Flexible Scheduling</span>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative animate-fade-in animation-delay-200">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-sky-200/50">
              <img
                src="https://images.unsplash.com/photo-1597595735781-6a57fb8e3e3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGRvZyUyMGdyb29taW5nJTIwc2Fsb24lMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcyNTYwMDcwfDA&ixlib=rb-4.1.0&q=85"
                alt="Happy groomed dog at professional grooming salon"
                className="w-full h-auto object-cover aspect-[4/3]"
                data-testid="hero-image"
              />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-white rounded-2xl p-4 shadow-xl animate-fade-in animation-delay-400">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
                  <Sparkles className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <p className="font-semibold text-slate-900">5-Star Rated</p>
                  <p className="text-sm text-slate-500">Local Pet Grooming</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
